import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export function Login({ onLoggedIn }: { onLoggedIn?: () => void }) {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const next = params.get("next") ?? "/";

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(password);
      onLoggedIn?.();
      // Full navigation so the browser socket reconnects with the new cookie.
      location.assign(next.startsWith("/") ? next : "/");
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="panel login" onSubmit={submit}>
        <h2>Facade Inspector</h2>
        <label className="muted" htmlFor="pw">
          admin password
        </label>
        <input id="pw" type="password" autoFocus autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        {error && <div className="login-error">{error}</div>}
        <button className="primary" type="submit" disabled={busy || !password}>
          {busy ? "signing in…" : "sign in"}
        </button>
      </form>
    </div>
  );
}
